import styled from '@emotion/styled'
import { SKIP_DOLLAR_PROPS } from '@helpers/styles'
import { ListItemIcon, type Theme } from '@mui/material'

interface SelectableItem {
	$isSelected: boolean
}

export const ITEM_BASE_SX = {
	borderRadius: '8px',
	margin: '2px 6px',
	position: 'relative' as const,
}

export const ITEM_SELECTED_SX = {
	...ITEM_BASE_SX,
	bgcolor: 'action.selected',
	'&::before': {
		content: '""',
		position: 'absolute',
		left: 0,
		top: '20%',
		height: '60%',
		width: '3px',
		borderRadius: '0 2px 2px 0',
		bgcolor: 'primary.main',
	},
}

export const StyledLabel = styled('h6')<SelectableItem>`
	font-size: 0.9375rem;
	line-height: 1.5;
	margin: 0;
	font-weight: ${({ $isSelected }) => ($isSelected ? 600 : 400)};
	${({ $isSelected, theme }: { $isSelected: boolean; theme: Theme }) => `
		color: ${$isSelected ? theme.palette.primary.main : theme.palette.text.primary};
	`}
`

export const StyledListItemIcon = styled(
	ListItemIcon,
	SKIP_DOLLAR_PROPS
)<SelectableItem>`
	height: ${({ theme }: { theme: Theme }) => theme.spacing(5)};
	align-items: center;
	justify-content: center;
	align-content: center;
	margin: 0 10px;
	min-width: ${({ theme }: { theme: Theme }) => theme.spacing(5)} !important;
	padding: 0;
	svg {
		rect,
		path {
			fill: ${({
				theme,
				$isSelected,
			}: {
				theme: Theme
				$isSelected: boolean
			}) =>
				$isSelected
					? theme.palette.primary.main
					: theme.palette.text.secondary};
		}
	}
`
